import { SearchOutlined } from '@ant-design/icons';
import { Button, Input, Space } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { t } from 'ttag';

export const SearchFilterIcon = filtered => (
  <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
);

const Wrap = styled.div`
  padding: 8px;

  .ant-input {
    width: 188px;
    margin-bottom: 8px;
    display: block;
  }

  .ant-btn {
    width: 90px;
  }
`;

const SearchFilter = ({ setSelectedKeys, selectedKeys, confirm, clearFilters, visible }) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (!visible) return () => {};

    // We cannot use `autoFocus` prop because this component doesn't get unmounted when hidden.
    // We also need to use setTimeout to ensure that the input is focused after the animation is complete.
    // Actually, instead of `.focus` we use `.select` to highlight the existing text, making it quicker to replace it.
    const id = setTimeout(() => inputRef.current?.select(), 0);
    return () => clearTimeout(id);
  }, [visible]);

  return (
    <Wrap>
      <Input
        ref={inputRef}
        placeholder={t`Search`}
        value={selectedKeys?.[0]}
        onChange={e => setSelectedKeys?.(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => confirm()}
      />
      <Space>
        <Button type="primary" onClick={() => confirm()} icon={<SearchOutlined />} size="small">
          {t`Search`}
        </Button>
        <Button onClick={clearFilters} size="small">
          {t`Clear`}
        </Button>
      </Space>
    </Wrap>
  );
};

SearchFilter.propTypes = {
  setSelectedKeys: PropTypes.func,
  selectedKeys: PropTypes.arrayOf(PropTypes.string),
  confirm: PropTypes.func,
  clearFilters: PropTypes.func,
  visible: PropTypes.bool,
};

export default SearchFilter;
